import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "./styles/global.scss"
import App from "./app.tsx"
import * as Sentry from "@sentry/react"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: import.meta.env.VITE_NODE_ENV,

  // Not actionable for us: browser extensions injecting into the page,
  // user-denied browser permissions, cancelled requests, and the benign
  // ResizeObserver loop warning.
  ignoreErrors: [
    /Failed to connect to MetaMask/,
    /Object Not Found Matching Id/,
    "NotAllowedError",
    "AbortError",
    /ResizeObserver loop/,
  ],
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
